const rollDown = {
  mounted() {
    let waitAndGo = 0;
    const wheelToGo = 4;
    this.$el.addEventListener('wheel', (e) => {
      e.deltaY > 0 ? waitAndGo += 1 : waitAndGo -= 1;
      if (waitAndGo >= wheelToGo) {
        this.$router.push(this.nextScreen);
      }
    });
  },
};

export default rollDown;



// WEBPACK FOOTER //
// ./src/components/mixins/rollDown.js